import { render } from "./user-logged-in.vue?vue&type=template&id=5553fee8"
import script from "./user-logged-in.vue?vue&type=script&lang=js"
export * from "./user-logged-in.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__